import React, { useState } from "react";
import "./LawyersConnectTerms.css";
import Navbar from "../header";
import Footer from "../footer";

const TermsAndConditions = () => {
  const [activeTab, setActiveTab] = useState("clients");

  return (
    <>
       <Navbar   menuColor="red" />
    <div className="lc-page">
      <div className="lc-hero">
        <div className="lc-hero-overlay"></div>

        <div className="lc-hero-content"  style={{ color: "white"}}>
          <h1>Terms & Conditions</h1>
          <p>
            Lawyers Connect Platform Policies, Privacy Practices and User
            Obligations.
          </p>
        </div>
      </div>

      <div className="lc-container">
        <div className="lc-tabs">
          <button
            className={activeTab === "clients" ? "lc-tab active" : "lc-tab"}
            onClick={() => setActiveTab("clients")}
          >
            Clients
          </button>

          <button
            className={activeTab === "lawyers" ? "lc-tab active" : "lc-tab"}
            onClick={() => setActiveTab("lawyers")}
          >
            Lawyers
          </button>
        </div>

        {activeTab === "clients" && (
          <div className="lc-card">
            <h2>Terms & Conditions and Privacy Policy for Clients</h2>

            <div className="lc-badge">
              Last Updated: June 1, 2026
            </div>

            <section>
              <h3>Who We Are</h3>
              <p>
                Lawyers Connect is a legal service centre that connects clients
                with verified lawyers.
              </p>
            </section>

            <section>
              <h3>Information & Data Collection and Usage</h3>
              <p>
                When you use the platform, we collect your name, contact
                details, case details, identification documents for
                verification, payment information and device data.
              </p>

              <p>
                We collect this information to connect you with licensed
                lawyers, process payments, verify accounts, prevent fraud and
                comply with applicable Nigerian laws.
              </p>
            </section>

            <section>
              <h3>Confidentiality</h3>
              <p>
                Communications with lawyers on the Lawyers Connect platform are
                confidential and protected under applicable professional conduct
                rules.
              </p>

              <p>We only disclose information when:</p>

              <ul>
                <li>Required by a court order.</li>
                <li>Required by the Nigerian Data Protection Commission.</li>
                <li>Necessary to prevent crime or serious harm.</li>
                <li>You provide consent.</li>
              </ul>
            </section>

            <section>
              <h3>Your Rights</h3>
              <p>
                You may request access, correction, deletion or portability of
                your personal data at any time.
              </p>

              <p>
                Email our Data Protection Officer at:
                <strong>  support@lawyersconnect.com.ng</strong>
              </p>

              <p>
                Requests are handled within 30 days in accordance with the NDPA.
              </p>
            </section>

            <section>
              <h3>Security</h3>
              <p>
                We encrypt data both in transit and at rest. If a security
                breach creates a risk to your rights and freedoms, we will
                notify affected users and the Nigeria Data Protection Commission
                within 72 hours.
              </p>
            </section>

            <section>
              <h3>Data Retention</h3>
              <p>
                We retain personal data only as long as necessary for the
                management of your legal matter and for seven (7) years
                thereafter to satisfy legal and regulatory obligations.
              </p>
            </section>

            <section>
              <h3>Off-Platform Dealing & Anti-Circumvention</h3>

              <h4>Prohibition</h4>

              <p>
                Once a Lawyer and Client are connected through Lawyers Connect,
                both parties agree not to bypass or circumvent the platform for
                the purpose of avoiding platform fees for 24 months from the
                date of first connection.
              </p>

              <h4>Examples of Bypassing</h4>

              <ul>
                <li>
                  Exchanging direct contact details to avoid platform fees.
                </li>
                <li>
                  Entering into separate agreements for the same legal matter.
                </li>
                <li>
                  Paying lawyers directly through external payment methods.
                </li>
                <li>
                  Using Lawyers Connect only for introductions and continuing
                  work elsewhere.
                </li>
              </ul>

              <h4>Why This Rule Exists</h4>

              <ul>
                <li>
                  Supports verification, escrow and dispute resolution systems.
                </li>
                <li>Protects lawyers from non-payment risks.</li>
                <li>
                  Preserves client access to escrow protection and documented
                  records.
                </li>
              </ul>
            </section>

            <section>
              <h3>Liquidated Damages</h3>
              <p>
                Any party found in breach agrees to pay liquidated damages equal
                to 25% of the total fee paid or payable for the legal matter,
                subject to a minimum penalty of ₦50,000 per breach.
              </p>
            </section>

            <section>
              <h3>Discovery & Enforcement</h3>

              <p>
                Lawyers Connect may investigate suspected breaches using:
              </p>

              <ol>
                <li>Platform message logs and metadata.</li>
                <li>Payment pattern analysis.</li>
                <li>User reports.</li>
                <li>Public records and social media information.</li>
              </ol>

              <p>
                We may suspend accounts, withhold escrow funds and pursue legal
                recovery through Nigerian courts where appropriate.
              </p>
            </section>

            <section>
              <h3>Severability</h3>
              <p>
                If any provision is found unenforceable, the remaining
                provisions shall remain valid and enforceable.
              </p>
            </section>

            <section>
              <h3>Survival</h3>
              <p>
                The anti-circumvention obligations survive account termination
                for a period of 24 months.
              </p>
            </section>
          </div>
        )}

        {activeTab === "lawyers" && (
          <div className="lc-card">
            <h2>Terms & Conditions and Privacy Policy for Lawyers</h2>

            <div className="lc-badge">
              Effective From June 1, 2026
            </div>

            <section>
              <h3>Eligibility & Conduct</h3>
              <p>
                You confirm that you are a licensed legal practitioner and that
                your professional credentials remain valid and current.
              </p>
            </section>

            <section>
              <h3>Platform Role</h3>
              <p>
                Lawyers Connect acts solely as a technology intermediary. We do
                not provide legal advice or establish attorney-client
                relationships.
              </p>
            </section>

            <section>
              <h3>Confidentiality & Data</h3>
              <p>
                All client communications remain confidential and must be
                handled in accordance with applicable professional conduct and
                data protection requirements.
              </p>
            </section>

            <section>
              <h3>Intellectual Property</h3>
              <p>
                You grant Lawyers Connect permission to display your profile and
                related content for service delivery purposes. All platform
                software, branding and proprietary content remain the property
                of Lawyers Connect.
              </p>
            </section>

            <section>
              <h3>Fees & Payments</h3>
              <p>
                Fees are agreed between lawyers and clients through the
                platform. Payments are processed through Lawyers Connect and
                remitted after applicable deductions.
              </p>
            </section>

            <section>
              <h3>Prohibited Conduct</h3>

              <ul>
                <li>Soliciting illegal acts.</li>
                <li>Providing false credentials.</li>
                <li>Uploading copyrighted content without permission.</li>
                <li>Harassing clients.</li>
              </ul>
            </section>

            <section>
              <h3>Data Processing</h3>
              <p>
                Lawyers Connect acts as a Data Processor while lawyers act as
                Data Controllers for their professional records.
              </p>
            </section>

            <section>
              <h3>Limitation of Liability</h3>
              <p>
                Lawyers Connect shall not be liable for the quality of legal
                services rendered or for data breaches caused by lawyer
                negligence.
              </p>

              <p>
                Total liability is limited to fees paid to Lawyers Connect
                during the preceding three months.
              </p>
            </section>

            <section>
              <h3>Dispute Resolution</h3>
              <p>
                Disputes shall be governed by Nigerian law and resolved through
                mediation and arbitration.
              </p>
            </section>

            <section>
              <h3>Termination</h3>
              <p>
                Either party may terminate participation with 14 days notice.
                Lawyers Connect may terminate access immediately for violations
                of these terms.
              </p>
            </section>

            <section>
              <h3>Changes</h3>
              <p>
                Users will receive at least seven (7) days notice before
                material changes become effective.
              </p>
            </section>

            <section>
              <h3>Contact</h3>
              <p>[Legal / Compliance Email]</p>
            </section>

            <section>
              <h3>Off-Platform Dealing & Anti-Circumvention</h3>

              <p>
                Lawyers and clients connected through Lawyers Connect must not
                bypass platform payment systems for 24 months following their
                first connection.
              </p>

              <h4>Liquidated Damages</h4>

              <p>
                Breaches attract liquidated damages equal to 25% of fees paid
                or payable, subject to a minimum penalty of ₦50,000.
              </p>

              <h4>Discovery & Enforcement</h4>

              <ol>
                <li>Platform message logs and metadata.</li>
                <li>Payment pattern analysis.</li>
                <li>User reports.</li>
                <li>Public records and social media.</li>
              </ol>
            </section>
          </div>
        )}
      </div>
    </div>

    
    <Footer/>
    </>
  );
};

export default TermsAndConditions;